import { z } from 'zod';

export const InspectionArea = z.enum(['exterior', 'brightwork-boots', 'interior']);
export type InspectionArea = z.infer<typeof InspectionArea>;
